module.exports = __webpack_public_path__ + "img/07.1074d0b7.png";